import { ServiceHandler } from '../../../utils/api.utils';
import type {
  AgentDataset,
  AgentDatasetItem,
  AgentDatasetVersion,
  DatasetUploadResponse,
} from '../types';

export const getDatasets = ServiceHandler<
  unknown,
  { datasets: AgentDataset[] }
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets',
});

export const createDataset = ServiceHandler<
  { name: string; description?: string },
  AgentDataset
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets',
  method: 'POST',
});

export const updateDataset = ServiceHandler<
  { name?: string; description?: string },
  AgentDataset
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId',
  method: 'PUT',
});

export const deleteDataset = ServiceHandler<unknown, { deleted: boolean }>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId',
  method: 'DELETE',
});

export const getDatasetVersions = ServiceHandler<
  unknown,
  { versions: AgentDatasetVersion[] }
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId/versions',
});

export const getDatasetItems = ServiceHandler<
  unknown,
  { items: AgentDatasetItem[]; itemCount: number }
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId/versions/:versionId/items',
});

export const replaceDatasetItems = ServiceHandler<
  { items: Partial<AgentDatasetItem>[] },
  AgentDatasetVersion
>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId/versions/:versionId/items',
  method: 'PUT',
});

export const uploadDatasetCsv = ServiceHandler<FormData, DatasetUploadResponse>(
  {
    url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId/upload',
    method: 'POST',
  }
);

export const publishDataset = ServiceHandler<void, AgentDatasetVersion>({
  url: '/api/chat-agent/v1/agents/:agentId/datasets/:datasetId/publish',
  method: 'POST',
});
